var $3dbb2e0cac70c4cc$exports = {};
$3dbb2e0cac70c4cc$exports = {
    "valid": `\xc9rv\xe9nyes`
};


export {$3dbb2e0cac70c4cc$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
